import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";
import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _templateObject;
var _excluded = ["alignTop", "direction"];
import styled from "@emotion/styled";
import { useCombinedThemeMode } from "@smartsheet/sds-theme-internal";
import React from "react";
import { forwardRef } from "react";
import { sizes } from "../../../constants/spacing";
import { scrollAreaTheme } from "../scrollAreaTheme";
import { resolveGutterLength } from "../utils/resolveGutterLength";
export var KEYLINE_WIDTH_PROPERTY_NAME = "--smar--lodestar-core--keyline-width-as9dpu";
export var KEYLINE_HEIGHT_PROPERTY_NAME = "--smar--lodestar-core--keyline-height-as9dpu";
export var Keyline = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var alignTop = _ref.alignTop,
    _ref$direction = _ref.direction,
    direction = _ref$direction === void 0 ? "vertical" : _ref$direction,
    props = _objectWithoutProperties(_ref, _excluded);
  var themeMode = useCombinedThemeMode();
  return /*#__PURE__*/React.createElement(KeylineStyled, _extends({}, props, {
    ref: ref,
    alignment: alignTop ? "start" : "end",
    themeMode: themeMode,
    direction: direction
  }));
});
Keyline.displayName = "Keyline";
var KeylineStyled = styled("div", {
  shouldForwardProp: function shouldForwardProp(propName) {
    switch (propName) {
      case "direction":
      case "alignment":
      case "gutter":
      case "themeMode":
        return false;
      default:
        return true;
    }
  }
})(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    position: absolute;\n    pointer-events: none;\n\n    ", ";\n\n    margin-left: ", ";\n\n    height: var(", ", auto);\n    width: var(", ", auto);\n\n    // This hides this element, but allows the box-shadow to still be visible.\n    overflow: hidden;\n\n    // This provides the box-shadow for the keyline.\n    &::before {\n        content: \"\";\n        display: block;\n\n        transform: ", ";\n        box-shadow: ", ";\n\n        // TODO use tokens for this\n        transition: box-shadow 450ms cubic-bezier(0.3, 0.3, 0.2, 1) 0s, margin 450ms cubic-bezier(0.3, 0.3, 0.2, 1) 0s,\n            width 450ms cubic-bezier(0.3, 0.3, 0.2, 1) 0s, height 450ms cubic-bezier(0.3, 0.3, 0.2, 1) 0s;\n        opacity: ", ";\n\n        // This dimension length allows the box-shadow to be properly offset from its parent.\n        // This value depends on the box-shadow's blur and offset values.\n        ", "\n    }\n"])), function (_ref2) {
  var direction = _ref2.direction,
    alignment = _ref2.alignment;
  switch (alignment) {
    case "start":
      return direction === "vertical" ? "top: 0" : "left: 0";
    case "end":
      return direction === "vertical" ? "bottom: 0" : "right: 0";
  }
}, function (_ref3) {
  var direction = _ref3.direction,
    gutter = _ref3.gutter;
  // Don't support gutter in horizontal mode. We'd rather not support the gutter prop at all
  // since it's generally not what you want.
  if (direction === "horizontal") {
    return "none";
  }
  switch (gutter) {
    case "none":
      return "0px";
    case "legacy":
      return "".concat(sizes.xLarge, "px");
    default:
      return resolveGutterLength(gutter);
  }
}, KEYLINE_HEIGHT_PROPERTY_NAME, KEYLINE_WIDTH_PROPERTY_NAME, getTransform, getBoxShadow, function (_ref4) {
  var isVisible = _ref4.isVisible;
  return isVisible ? 1 : 0;
}, function (_ref5) {
  var direction = _ref5.direction,
    isScrolling = _ref5.isScrolling;
  switch (direction) {
    case "vertical":
      return "\n                        height: 16px;\n                        width: ".concat(isScrolling ? "calc(100% - 8px)" : "100%", ";\n                        margin-left: ").concat(isScrolling ? "4px" : "0", ";\n                    ");
    case "horizontal":
      return "\n                        height: ".concat(isScrolling ? "calc(100% - 8px)" : "100%", ";\n                        width: 16px;\n                        margin-top: ").concat(isScrolling ? "4px" : "0", ";\n                    ");
  }
});
function getBoxShadow(_ref6) {
  var themeMode = _ref6.themeMode,
    alignment = _ref6.alignment,
    direction = _ref6.direction,
    isScrolling = _ref6.isScrolling,
    includeScrollingIndication = _ref6.includeScrollingIndication;
  return includeScrollingIndication && isScrolling ? scrollAreaTheme.keyline[alignment].boxShadow[direction].scrolling(themeMode) : scrollAreaTheme.keyline[alignment].boxShadow[direction].rest(themeMode);
}
function getTransform(_ref7) {
  var direction = _ref7.direction,
    alignment = _ref7.alignment;
  switch (direction) {
    case "vertical":
      return alignment === "start" ? "translateY(-16px)" : "translateY(16px)";
    case "horizontal":
      return alignment === "start" ? "translateX(-16px)" : "translateX(16px)";
  }
}
//# sourceMappingURL=Keyline.js.map